import React, { useEffect, useState } from "react";
import { Paciente, Turno, Usuario } from "../../interfaces";
import {
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonItem,
  IonList,
  IonModal,
  IonRow,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import StyledButton from "../StyledButton/StyledButton";
import dayjs from "dayjs";
import useNotificacion from "../../hooks/notificacion";

import { useHistory } from "react-router";
import { useSession } from "../../hooks/SessionContext";

import http from "../../hooks/httpAdapter";
import useTituloPagina from "../../hooks/tituloPagina";
require("dayjs/locale/es");

interface ContainerProps {
  abrirModal: boolean;
  setAbrirModal: (abrir: boolean) => void;
}
const ModalTurnosPaciente: React.FC<ContainerProps> = ({ abrirModal, setAbrirModal }) => {
  const [listadoTurnos, setListadoTurnos] = useState<Turno[]>([]);

  const { hcUL, cargandoSession, pacienteCargado, setSesionInvalida, mostrarNotificacion } =
    useSession();
  const history = useHistory();
  useTituloPagina();

  const traerTurnosPaciente = async () => {
    let turnos = [];
    const config = {
      headers: { Authorization: `Bearer ${hcUL?.token}` },
    };

    try {
      const response = await http()
        .get(
          `Turnos/TurnosPaciente/?paciente=${pacienteCargado?.codigo}`,

          config
        )
        .catch((e) => {
          if (e.response && e.response.status === 401) {
            setSesionInvalida(true);
            // history.push("/", { motivoRedireccion: "401" }); // Redirección en caso de error 401
          } else {
            console.error(e);
          }
        });
      if (response.length !== 0) {
        turnos = response.map((turno: any) => {
          return {
            codigo: turno.codigo,
            fecha: turno.fecha,
            hora: turno.hora,
            prestadorCod: turno.prestadorCod,
            prestadorNom: turno.prestadorNom,
            origenTurno: "",
            libre: false,
            paciente: pacienteCargado?.codigo,
            pacienteNom: "",
            pacienteDocumento: 0,
            especialidadCod: turno.especialidad,
            especialidadNom: turno.especialidadNom,
            mutual: turno.mutual,
            mutualNom: turno.mutualNom,
            asistio: turno.asistio,
            servicio: 0,
            telemedicina: 0,
            cancelado: turno.aCancelar,
            atendidoHora: turno.atendidoHora,
            fechaOrigen: "",
            horaOrigen: "",
            reservado: true,
            observaciones: turno.observaciones,
            entreTurno: false,
          };
        });
      }

      setListadoTurnos(turnos);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ocurrió un problema al intentar consultar sus turnos registrados",
        "rojo"
      );
    }
  };

  useEffect(() => {
    if (cargandoSession === false) {
      if (pacienteCargado !== null && pacienteCargado.codigo !== 0) {
        if (pacienteCargado?.codigo !== 0 && abrirModal) {
          traerTurnosPaciente();
        }
      } else {
        mostrarNotificacion(true, "Error: " + "No se encuentra al paciente", "rojo");
      }
    }
  }, [pacienteCargado, abrirModal, cargandoSession]);

  return (
    <IonModal isOpen={abrirModal} onDidDismiss={() => setAbrirModal(false)}>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Turnos del paciente</IonTitle>
          <StyledButton slot="end" fill="clear" expand="full" onClick={() => setAbrirModal(false)}>
            Cancelar
          </StyledButton>
        </IonToolbar>
      </IonHeader>
      {listadoTurnos.length <= 0 ? (
        <IonGrid>
          <IonRow className="ion-justify-content-center">
            <IonCol>
              <div className="ion-text-center">
                <small>No tiene turnos registrados</small>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      ) : (
        <>
          {/* Tabla */}
          <IonContent>
            <IonGrid className="tabla">
              <IonList lines="none">
                <IonItem className="fila cabecera">
                  <IonCol className="celda cabecera" size="3">
                    <>Fecha</>
                  </IonCol>
                  <IonCol className="celda cabecera" size="3">
                    <>Prestador</>
                  </IonCol>
                  <IonCol className="celda cabecera" size="3">
                    <>Mutual</>
                  </IonCol>
                  <IonCol className="celda cabecera" size="3">
                    <>Estado</>
                  </IonCol>
                </IonItem>
                {listadoTurnos.map((fila) => (
                  <IonItem key={fila.codigo} className="fila">
                    <IonCol className="celda" size="3">
                      <small>{`${dayjs(fila.fecha).format("DD/MM/YYYY")} ${dayjs(fila.hora).format(
                        "HH:mm"
                      )}`}</small>
                    </IonCol>
                    <IonCol className="celda" size="3">
                      <small>{fila.prestadorNom}</small>
                    </IonCol>
                    <IonCol className="celda" size="3">
                      {/* <small>{fila.mutualNom}</small> */}
                    </IonCol>
                    <IonCol className="celda" size="3">
                      <small>
                        {fila.asistio
                          ? "Asistido"
                          : !fila.cancelado
                          ? "Cancelado"
                          : dayjs(fila.fecha).isAfter(dayjs())
                          ? "Pendiente"
                          : "No asistido"}
                      </small>
                    </IonCol>
                  </IonItem>
                ))}
              </IonList>
            </IonGrid>
          </IonContent>
        </>
      )}
    </IonModal>
  );
};

export default ModalTurnosPaciente;
